module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ch-no"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "ch-title"
  }, [_vm._v("A Princeton Freshman")]), _vm._v(" "), _c('p', {
    staticClass: "ch-head"
  }, [_vm._v("1913–1914")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The news from Princeton was that Fitzgerald’s performance on the entrance exams was not good enough to warrant admission. Make-up exams and a personal interview were required. Fitzgerald traveled to Princeton and persuaded the admissions committee to accept him by pleading that it would be too cruel to deny him a place in the Class of 1917 on his birthday. On 24 September 1913 he wired home: ADMITTED SEND FOOTBALL PADS AND SHOES IMMEDIATELY PLEASE WAIT TRUNK."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-1",
      "id": "pt3_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])]), _vm._v(" It was a near thing; he was admitted with conditions in algebra, Latin, French, and physics—which had to be made up by passing exams in December. (Of the 430 freshmen, 66 percent were admitted with conditions.)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fitzgerald described pre–World War I Princeton as “the pleasantest country club in America,”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-2",
      "id": "pt3_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" where he planned to succeed according to the guidelines set forth in Owen Johnson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stover at Yale.")]), _vm._v(" The town was not yet a bedroom community for New York commuters; “the loveliest riot of Gothic architecture in America”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-3",
      "id": "pt3_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])]), _vm._v(" was an academic town surrounded by country estates. “Horsing,” a mild form of hazing, was practiced on freshmen, and they were forbidden to wear soft shirts or cuffed trousers. Presbyterian Princeton was still a strait-laced university. Although there were undergraduates who frequented the fleshpots of New York, organized Christianity was a strong force on campus. The Philadelphian Society was an influential campus religious organization, and daily chapel attendance was compulsory until September 1915. In the 1917 class survey, 182 out of 333 seniors claimed to have kissed a girl, and 41 stated that they regarded kissing as morally wrong. Only 117 admitted that they drank, and 61 regarded drinking as morally wrong. The campus tennis nets were taken down on Sunday.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Big Man on Campus at certain Eastern universities was a figure of almost national prominence among the prep school and Ivy League population. Social success was regarded with intense seriousness. The quickest way to campus recognition was on the football field, and Fitzgerald reported for"), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v(" freshman practice at five foot seven and 138 pounds. In those days 140- or 150-pounders played first-string football, but it required physical toughness and ability that Fitzgerald did not have. Hobey Baker ’14, captain of the football team during Fitzgerald’s freshman year, was the greatest athlete in Princeton’s history. At five foot nine and 167 pounds, playing without a helmet, the star halfback seemed like a Galahad figure on and off the field and was the most exciting ball carrier of his time. Baker was precisely the sort of hero Fitzgerald could identify with, and he was one of the players who made Big Three football glamorous in the days when it was regarded as a gentleman’s sport.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("According to one report, Fitzgerald wrenched his knee in practice and had to withdraw; another report is that he was cut from the squad on the first day of practice. In either case, within a week the road to gridiron glory was closed—leaving him with a “dream of a defeated dream” that he used to induce sleep for the next twenty years:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "para-b"
  }, [_vm._v("“Once upon a time” (I tell myself) “they needed a quarterback at Princeton, and they had nobody and were in despair. The head coach noticed me kicking and passing on the side of the field, and he cried: ‘Who is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" man—why haven’t we noticed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(" before?’ The under coach answered, ‘He hasn’t been out,’ and the response was: ‘Bring him to me!”’")]), _vm._v(" "), _c('p', {
    staticClass: "para-b"
  }, [_vm._v("“… we go to the day of the Yale game. I weigh only one hundred and thirty-five, so they save me until the third quarter, with the score—”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-4",
      "id": "pt3_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("Again Fitzgerald turned to his pencil for compensatory recognition, going out for the Triangle Club and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Princeton Tiger,")]), _vm._v(" the humor magazine. College humor magazines were then approaching the peak of reputation they would occupy in the Twenties when the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger, Yale Record,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Lampoon")]), _vm._v(" had national readerships and were incubators for successful writers. The first fall 1913 issue of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger")]), _vm._v(" had an unidentified Fitzgerald contribution. He almost certainly contributed to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger")]), _vm._v(" throughout his freshman year, but none of his contributions before 1915 has been identified because there were few bylines. Most of his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger")]), _vm._v(" work is known only by the clippings he saved."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-5",
      "id": "pt3_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" Fitzgerald entered Princeton with no clear career plans beyond the determination to earn his living by writing, probably as a newspaperman. Students preparing for journalism usually worked on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Daily Princetonian,")]), _vm._v(" but Fitzgerald did not go out for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prince.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although Princeton was regarded as a college for the sons of the rich, and most of its students came from prep schools, the fees were not higher than at other colleges of its class. Tuition was $160 per year; room, board,"), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v(" and other fees averaged $350. Fitzgerald never lacked for money at Princeton, and his expenses may have run as high as $2,000 a year—roughly a third of his family’s income.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During his first year Fitzgerald roomed alone off campus at 15 University Place because there was not enough dormitory space for freshmen. Two of his Newman classmates, Sap Donahoe and Paul Nelson, also roomed there. Norris Jackson from the St. Paul Academy was in the Class of ’17, and another St. Paul friend, Joe McKibbin, was a popular member of the Class of 1915. Through his work with the Triangle Club, Fitzgerald met two wealthy freshmen, Townsend Martin and Ludlow Fowler, who were roommates. Alexander McKaig ’17, a new friend with literary ambitions, was active on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prince")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nassau Literary Magazine.")]), _vm._v(" Although Fitzgerald was not friendless, he was up against the most complex system of social stratification he had yet encountered. The delegations from the Princeton feeder schools—Lawrenceville, Hill, Hotchkiss, Exeter, Andover—arrived with inside knowledge about Princeton and provided each other with support. The boy from an unimpressive Catholic prep school felt that he was a member of the lower class. He did not resent the existence of a rigid class system, but he wanted to be at the top of the Princeton social ladder.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On 15 November 1913 Fitzgerald went to New Haven to watch Princeton and Yale play a 3-3 tie as Hobey Baker drop-kicked a 43-yard field goal. The lasting impression of the game for Fitzgerald was Princeton’s Buzz Law kicking from behind his own goal line with a bandage around his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There were classes. As a candidate for a Litt. B. or a B.S. degree (the A.B. required Greek), Fitzgerald was assigned six compulsory courses: Latin 103 (historical literature of Rome—Livy, Sallust, Cicero), Mathematics 101 (plane trigonometry), English 101 (readings in English literature—composition and rhetoric), Physics 101 (general physics), French 203 (survey of French literature), and Hygiene 101 (personal hygiene). In addition there was physical education as well as a seventh academic course in Mathematics 105 (algebra) to prepare him to clear his entrance conditions in math.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The method of instruction was the preceptorial system, a modification of the Oxford-Cambridge tutorial system, introduced in 1905 by Woodrow Wilson when he was president of Princeton. The lectures in each course were supplemented by weekly one-hour meetings with preceptors; three to six students attended each preceptorial session. The Princeton grading system was by groups: First group, highest standing; Second group, high standing; Third group, satisfactory; Fourth group, below average; Fifth group, poor; Sixth group, unsatisfactory; Seventh group, very unsatisfactory. Fitzgerald’s record for the first term of his freshman year shows 5 in Latin;"), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v(" failed/failed/passed in trigonometry (he took the exam three times); 4 in English; 5 in physics; 5 in French; failed/passed in hygiene; failed/failed/passed in algebra. His average of 5.17 for the term was barely passing. Since failed courses had to be made up, in addition to his entrance conditions, Fitzgerald established a pattern of having to make up for past failures while failing current courses. It was a predicament that would get worse every term.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Princeton English department—though not a great department—included such respected figures as Henry Van Dyke, George MacLean Harper, Thomas Marc Parrott, J. Duncan Spaeth, Charles G. Osgood, and Gordon Hall Gerould. The English poet Alfred Noyes, author of “The Highwayman,” joined the department in 1914. Fitzgerald found most of his teachers disappointing and characterized them as having “an uncanny knack of making literature distasteful to young men.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-6",
      "id": "pt3_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" The only one of his English teachers he acknowledged a debt to was CourtlandVan Winkle, who taught him in freshman year: “… he gave us the book of Job to read and I don’t think any of our preceptorial group ever quite recovered from it.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-7",
      "id": "pt3_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])]), _vm._v(" Fitzgerald gave Professor Spaeth credit for arousing “interest and even enthusiasm for the romantic poets, an interest later killed in the preceptorial rooms where mildly poetic gentlemen resented any warmth of discussion and called the prominent men of the class by their first names.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-8",
      "id": "pt3_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fitzgerald managed to remain in college by luck and by all-night cramming sessions with wet towels and pots of coffee. He regarded the Princeton honor system as a “sacred tradition.” “I can think of a dozen times when a page of notes glanced at in a wash room would have made the difference between failure and success for me, but I can’t recall any moral struggles in the matter.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-9",
      "id": "pt3_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])]), _vm._v(" The attrition rate was fairly high: 10 percent of the Class of 1917 did not survive freshman year. The removal of prep-school or parental supervision enabled some students to do no work at all, and the easy commute to Broadway terminated other undergraduate careers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Christmas vacation was splendid. As a Princeton man Fitzgerald was invited to so many parties and dances in St. Paul that he had to keep an engagement book. This may have been the holiday when, having gotten tight on Christmas Eve, he felt the need to hear hymns and went to St. John Evangelist Episcopal Church. With clinking overshoes he walked the aisles searching the congregation for a friend, remarking to the minister, “Don’t mind me, go on with the sermon.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-10",
      "id": "pt3_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Once he was away at school, Fitzgerald gradually stopped thinking of himself as a Midwesterner. The McQuillan connection became increasingly remote. The family roots that mattered to him were in Maryland, and he felt an immediate affinity with New York City. Yet his memories of Minnesota"), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v(" could exert an emotional pull on him. He evoked his sense of the Midwest as a place of exciting vacation returns in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Gatsby:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "para-b"
  }, [_vm._v("One of my most vivid memories is of coming back west from prep school and later from college at Christmas time. Those of us who went farther than Chicago would gather in the old dim Union Station at six o’clock of a December evening with a few Chicago friends already caught up into their own holiday gayeties to bid them a hasty goodbye. I remember the fur coats of the girls returning from Miss This or That’s and the chatter of frozen breath and the hands waving overhead as we caught sight of old acquaintances and the matchings for invitations: “Are you going to the Ordways’? the Herseys’? the Schultzes’?” and the long green tickets clasped tight in our gloved hands. And last the murky yellow cars of the Chicago, Milwaukee & St. Paul Railroad looking cheerful as Christmas itself on the tracks beside the gate."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-11",
      "id": "pt3_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("He returned to Princeton in January 1914 to take his midyear exams and begin hard work on the competition for the 1914–15 Triangle Club show. His book and lyrics for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fie! Fie! Fi-Fi!")]), _vm._v(" won the competition over the submission of Lawton Campbell ’16 from Montgomery, Alabama. The selection of the script was up to Walker Ellis ’15, the Triangle Club president, who may—as Campbell believed—have picked "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fie! Fie! Fi-Fi!")]), _vm._v(" because it had a good part for him. Ellis, whom Edmund Wilson charged with “brazen duplicities,”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-12",
      "id": "pt3_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])]), _vm._v(" revised it with the author until he decided to award himself credit for the dialogue and characters. The published libretto credits Fitzgerald with only the plot and lyrics."), _c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#star_6",
      "id": "star6"
    }
  }, [_vm._v("*")]), _vm._v(" It is impossible to determine how much of the produced play Ellis contributed. The plot deals with an American con man, who has become prime minister of Monaco, and his abandoned wife, the manicurist in a Monte Carlo hotel; a love subplot involves an Englishman and an American dancer. Ellis cast himself in the female lead as the manicurist, and the role of the dancer Celeste was reserved for Fitzgerald. The dialogue shows the influence of Oscar Wilde as the characters epigrammatize between song cues. Fitzgerald’s seventeen song lyrics were impressive work for a freshman who had never written a musical.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l1t"
  }, [_vm._v("A Slave to Modern Improvements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("A victim to modern improvements am I,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("I’ve a silver chest and a crystal eye;")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("A platinum lung and a grafted nose,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent-lt"
  }, [_vm._v("Aluminum fingers, asbestos toes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("And when I walk I clank and clash,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("And rust when damp, you see:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("And the wildest lot of anonymous trash")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("That ever crossed the sea."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-13",
      "id": "pt3_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("In April 1914 Fitzgerald began his friendship with a Princetonian who would shape his college education, most of which was acquired outside of classrooms. John Peale Bishop ’17 was three and a half years older than Fitzgerald, having started college late because of boyhood illness. Their meeting probably occurred very much as the meeting between Amory Blaine (Fitzgerald) and Thomas Park D’lnvilliers (Bishop) is reported in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise.")]), _vm._v(" Amory strikes up a conversation with a Princetonian at the Peacock Inn and discovers that the student is D’lnvilhers, the author of highbrow poetry in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lit:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "para-b"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("So he found “Dorian Gray” and the “Mystic and Sombre Dolores” and the “Belle Dame sans Merci”; for a month was keen on naught else. The world became pale and interesting, and he tried hard to look at Princeton through the satiated eyes of Oscar Wilde and Swinburne—or “Fingal O’Flaherty” and “Algernon Charles,” as he called them in précieuse jest. He read enormously every night—Shaw, Chesterton, Barrie, Pinero, Yeats, Synge, Ernest Dowson, Arthur Symons, Keats, Sudermann, Robert Hugh Benson, the Savoy Operas—just a heterogeneous mixture, for he suddenly discovered that he had read nothing for years."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-14",
      "id": "pt3_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("Bishop provided Fitzgerald with intensive tutoring in poetry. Writing to his daughter when she was in college, Fitzgerald acknowledged Bishop’s influence on his understanding of poetry:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "para-b"
  }, [_vm._v("It isn’t something easy to get started on by yourself. You need, at the beginning, some enthusiast who also knows his way around—John Peale Bishop performed that office for me at Princeton. I had always dabbled in “verse” but he made me see, in the course of a couple of months, the difference between poetry and non-poetry. After that one of my first discoveries was that some of the professors who were teaching poetry really hated it and didn’t know what it was about. I got in a series of endless scraps with them so that finally I dropped English altogether."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-15",
      "id": "pt3_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("Bishop was the first friend who fully shared Fitzgerald’s commitment to writing, and under his influence Fitzgerald began to develop more serious literary ambitions. For his part, Fitzgerald considered it his obligation to bring Bishop out—to direct him toward Princeton success. Since Bishop was from Charles Town, West Virginia, Fitzgerald regarded him as socially deprived, although Bishop had attended Mercersburg, a better-known school than Newman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It is not known when Fitzgerald met another member of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lit")]), _vm._v(" staff, Edmund Wilson ’16, who became a more enduring influence on him; but Bishop probably provided the connection. A graduate of the Hill School, Bunny Wilson had an imposing campus reputation as a scholar and literary critic. Fitzgerald’s friendship with Wilson was close but not intense at Princeton; Wilson was put off by Fitzgerald’s antics. Wilson later stated that Fitzgerald was the only Catholic he knew at Princeton. Fitzgerald subsequently delegated his intellectual responsibilities to him, admitting at the time of “The Crack-Up” in 1936: “… I had done very little thinking, save within the problems of my craft. For twenty years a certain man had been my intellectual conscience. That was Edmund Wilson.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-16",
      "id": "pt3_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While not especially literary, the Class of 1917 included—in addition to Fitzgerald and Bishop—other men who would become writers. Elliott White Springs used his experiences as a World War I ace to write aviation fiction "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(War Birds, Nocturne Militaire, Leave Me with a Smile)")]), _vm._v(" but later became better known for his Spring Maid sheet ads. George R. Stewart became a professor of English who wrote scholarly and popular books "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Storm).")]), _vm._v(" Townsend Martin wrote for the movies and had a Broadway success, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Most Immoral Lady.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In June 1914 Fitzgerald took his second-term exams and managed to pass everything but coordinate geometry, in which his grade was “a-” indicating that he was absent from the exam and that his term grade was unsatisfactory. His best grade was a 3 in English; his other grades were 4’s and 5’s. Fitzgerald’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ledger")]), _vm._v(" summary for his freshman year at Princeton was “A year of work and vivid experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While compiling a poor academic record, Fitzgerald was nonetheless acquiring an education through wide reading. The lessons he needed were"), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v(" not to be found in coordinate geometry or qualitative-analysis classes. The strongest influences on him were the novels he called “quest” books:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent-b"
  }, [_vm._v("In the “quest” book the hero sets off in life armed with the best weapons and avowedly intending to use them as such weapons are usually used, to push their possessors ahead as selfishly and blindly as possible, but the heroes of the “quest” books discover that there might be a more magnificent use for them. “None Other Gods” [Robert Hugh Benson], “Sinister Street” [Compton Mackenzie], and “The Research Magnificent” [H. G. Wells were examples of such books].…"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-17",
      "id": "pt3_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("The son of the Archbishop of Canterbury, Monsignor Robert Hugh Benson was a Catholic convert who wrote religious novels. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("None Other Gods")]), _vm._v(" (1910) a young English aristocrat forsakes his heritage when he converts to Catholicism and becomes a tramp, seeking spiritual fulfillment on the road. Benson, who had been at Cambridge with Shane Leslie, spoke at Princeton in March 1914. The social reform literature of Wells and George Bernard Shaw made a strong impression on Fitzgerald and his friends. Although Fitzgerald admired Wells for the power of his intelligence, and in 1917 cited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Machiavelli")]), _vm._v(" to Wilson as “the greatest English novel of the century”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-18",
      "id": "pt3_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])]), _vm._v(" it was Compton Mackenzies "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sinister Street")]), _vm._v(" that most clearly influenced him."), _c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#star_7",
      "id": "star7"
    }
  }, [_vm._v("*")]), _vm._v(" In 1922 Fitzgerald acknowledged that Mackenzie and Booth Tarkington “together taught me all I know about the English language.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-19",
      "id": "pt3_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sinister Street")]), _vm._v(" traces Michael Fane’s history at school and at Oxford, until he ends his quest in the arms of Rome as a priest. In the Oxford chapters the young gentlemen analyze and intellectualize with little interference from the university. This was Fitzgerald’s notion of how a university should be run. When he came to write his own quest novel, Fitzgerald imitated Mackenzie and to a lesser extent Wells. What Fitzgerald took from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sinister Street")]), _vm._v(" was an aristocratic egotism combined with a sense of noblesse oblige. Michael Fane and Amory Blaine (there is a name echo) share a concept of duty to their unique abilities and rare destinies. Both characters require goals that will employ their talents to serve some higher purpose—as did Fitzgerald.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was probably later on at Princeton that Fitzgerald discovered the American realists. Two novels that made a strong impression on him were Stephen French Whitman’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Predestined")]), _vm._v(" (1910) and Charles G. Norris’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Salt")]), _vm._v(" (1917)—"), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v(" both deterministic novels of character deterioration. Charles Norris’s work led Fitzgerald to the naturalistic novels of his brother, Frank Norris.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Father Fay kept in touch with his protégé, inviting him to visit the Fay family in Deal Beach, New Jersey, and introducing him to prominent figures in Catholic society. Fitzgerald remained a practicing—but not devout—Catholic at Princeton. He told Wilson, “Why I can go up to New York on a terrible party and then come back into the church and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pray")]), _vm._v("—and mean every word of it, too!”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-20",
      "id": "pt3_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])]), _vm._v(" He retained a strong sense of evil and sexual corruption. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise")]), _vm._v(" Fitzgerald summarized: “The problem of evil had solidified for Amory into the problem of sex … Inseparably linked with evil was beauty … Amory knew that every time he had reached toward it longingly it had leered out at him with the grotesque face of evil.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-21",
      "id": "pt3_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])]), _vm._v(" Though a connoisseur of kisses, Fitzgerald retained the capacity to be shocked by blatant sexuality. When Bishop and McKaig went off with two pick-ups, he declared to Wilson, “That’s one thing that Fitzgerald’s never done!”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-22",
      "id": "pt3_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the summer of 1914 Fitzgerald wrote his fourth and last play for the St. Paul Elizabethan Drama Club, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Assorted Spirits,")]), _vm._v(" a complicated ghost comedy in which he took a leading role and served as stage manager. It was performed at the Y.W.C.A. on 8 September and the next night at the White Bear Yacht Club—raising $500 for the Baby Welfare Association. There was the possibility of panic when a fuse blew at the yacht club performance. According to a local paper, “Fitzgerald proved equal to the situation, however, and leaping to the edge of the stage quieted the audience with an improvised monologue.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-23",
      "id": "pt3_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentfn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#star6",
      "id": "star_6"
    }
  }, [_vm._v("*")]), _vm._v(" The printed script for cast use is Fitzgerald’s first separate publication.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#star7",
      "id": "star_7"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sinister Street")]), _vm._v(" was published in two volumes in London, 1913–14; it was published in America as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Youth’s Encounter")]), _vm._v(" (1913) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sinister Street")]), _vm._v(" (1914).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c25302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/16_Chapter4.vue
// module id = 105
// module chunks = 0